import * as ActionTypes from "../action-types";

export const get_notification_request_thru_ws_request = (notifications) => dispatch => {
    dispatch(get_notification_request_thru_ws_success(notifications))
}

const get_notification_request_thru_ws_success = (notification) => {
    return {
        type: ActionTypes.GET_NOTIFICATION_THRU_WS,
        notification
    }
}

export const clear_notifications_request = () => {
    return {
        type: ActionTypes.CLEAR_NOTIFICATIONS
    }
}